<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button [disabled]="!habilitarNuevoProducto" type="button" class="btn btn-outline-success" title="Nuevo Producto" (click)="onAddProducto()"><i class="fa fa-file-o"></i> Nuevo Producto</button>
            <button [disabled]="!habilitarNuevoEmbalaje" type="button" class="btn btn-outline-success" title="Nuevo Embalaje" (click)="onAddEmbalaje()"><i class="fa fa-file-o"></i> Nuevo Embalaje</button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" class="btn btn-outline-success" title="Guardar Equipamiento" type="button" (click)="onGuardarMatriculas()"><i class="fa fa-save"></i> Guardar Equipamiento</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Productos {{ solicitudProductos?.CodigoSolicitud }}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{solicitudProductos?.IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{solicitudProductos?.IdEstadoSolicitudDescripcion}}" />
                <img *ngIf="solicitudProductos.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitudProductos.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitudProductos.IdEstadoChedPpDescripcion}}" />
                <img *ngIf="solicitudProductos.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitudProductos?.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudProductos?.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                <img class="predua-icono-big" container="body" ngbTooltip="{{solicitudProductos?.EsPredua | preduaNoPredua}}" src="{{solicitudProductos?.EsPredua | IconoPreduaSolicitud}}" />
                <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
            </span>
        </h5>
        <ng-container *ngIf="productoFitosanitarioFound">
            <div class="nota-info mb-2">
                <label class="col-form-label" for=""><i class="fa fa-info-circle" aria-hidden="true"></i> {{ messageProductoFitosanitarioLimit }}</label>
            </div>
        </ng-container>

        <div class="row">
            <div class="col-md-12">

                <ng-container *ngIf="idSolicitud">
                    <app-alertarechazo [id]="idSolicitud" [esImport]="true"></app-alertarechazo>
                </ng-container>

                <div class="row">
                    <!--GRID PRODUCTOS-->
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de productos</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductos?.TProductoSolicitudCollection"
                                         [columns]="colsProds" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductos?.TProductoSolicitudCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <!--RDLF: tarea producto Orgánico (93379) se comenta de manera temporal-->
                                                <!--<span *ngIf="(col.field!=='Link' && col.field!=='EsOrganico' && col.field!=='Grupo' && col.field!=='IdFormaDescripcion' && col.field !== 'Peso' && col.field !== 'Volumen')">
                        {{rowData[col.field]}}
                    </span>-->
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Grupo' && col.field!=='IdFormaDescripcion' && col.field !== 'Peso' && col.field !== 'Volumen')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field === 'Grupo' || col.field === 'IdFormaDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[25, '...'] }}
                                                </span>

                                                <span *ngIf="(col.field === 'Peso' || col.field === 'Volumen')">
                                                    {{rowData[col.field] | number:'1.3-3':'es'}}
                                                </span>
                                                <!--RDLF: tarea producto Orgánico (93379) se comenta de manera temporal-->
                                                <span *ngIf="(col.field === 'EsOrganico')">
                                                    {{rowData[col.field] | siNo }}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="productoEditable">
                                                        <button (click)="onEditProducto(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="!productoEditable && !esRechazoParcial">
                                                        <button (click)="onEditProducto(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="productoBorrable">
                                                        <button (click)="onDeleteProducto(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="rowData['EsDeCfCanarias']">
                                                        <!--ICONO producto de CF Canarias-->
                                                        <img class="icono-info-grid" src="./assets/images/Producto_Viene_de_CF.png" container="body" ngbTooltip="Viene de CF" />
                                                    </div>

                                                    <div *ngIf="esRechazoParcial">
                                                        <!--ICONO rechazo parcial-->
                                                        <img class="icono-info-grid" src="{{null | IconoProdsEmbsRp}}" container="body" ngbTooltip="Este producto se encuentra en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." />
                                                    </div>

                                                    <div *ngIf="esRechazoParcial">
                                                        <div *ngIf="rowData['Aceptado'] === true"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" ngbTooltip="Este producto se encuentra ACEPTADO en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." /></div>
                                                        <div *ngIf="rowData['Aceptado'] === false"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" ngbTooltip="Este producto se encuentra RECHAZADO en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." /></div>
                                                    </div>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="configuracionesIncompatibles && solicitudProductos?.TProductoSolicitudCollection?.length === 0" class="empty-grid">
                                    No se han clonado los productos ya que había configuraciones incompatibles para Importador / Lugar de destino en los productos existentes en la solicitud original
                                </div>

                                <div *ngIf="!configuracionesIncompatibles && solicitudProductos?.TProductoSolicitudCollection?.length === 0" class="empty-grid">
                                    No hay productos asociados a la solicitud
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <!--EQUIPAMIENTO-->

                    <div class="col-md-4">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-plus"></i> <strong id="stPerfil">Equipamiento</strong>
                            </div>
                            <div class="card-body-detalle-bot125">
                                <div class="collapse group-filtros-0" id="collapsedEquipamiento" [ngbCollapse]="isCollapsedEquipamiento">
                                    <div class="row">
                                        <div class="col-md-12">

                                            <div class="form-group">
                                                <div class="input-group">

                                                    <label class="col-form-label" [ngClass]="{ 'required-field' : EsPuerto }" for="">Matrícula / Nº Contenedor</label>

                                                    <div class="input-group">
                                                        <input formControlName="Matricula" name="Matricula" title="" class="form-control" id="inpDescripcion" type="text" value="">

                                                        <span class="input-group-btn">
                                                            &nbsp;<button [disabled]="!habilitarNuevaMatricula" name="btnAddMatricula" class="btn btn-list btn-secondary" type="button" title="Añade una Matrícula" (click)="onAddMatricula()"><i class="fa fa-plus"></i></button>
                                                        </span>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="col-md-12">

                                            <label class="cabeceraTablaDetalles">Matrículas / Nº Contenedor</label>
                                            <table class="table table-list table-sm table-0-marginbot">
                                                <!-- table-responsive -->
                                                <tbody>
                                                    <tr *ngFor="let item of solicitudProductos?.TSolicitudEquipamientoCollection">
                                                        <td>
                                                            <div class="btn-group">
                                                                <div *ngIf="matriculaBorrable">
                                                                    <button (click)="onDeleteMatricula(item)" type="button" title="Eliminar"
                                                                            class="btn btn-sm btn-danger">
                                                                        <span class="fa fa-remove"></span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td scope="col" class="td-list">{{item.Matricula}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                            <div class="invalid-feedback-collectionlist d-block" *ngIf="isFieldInvalidNoSubmit('IdPerfil','required')">
                                                * Debe añadir alguna matrícula / nº contenedor.
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!--</div>

                    <div class="row">-->
                    <!--GRID EMBALAJES-->
                    <div class="col-md-8">

                        <div class="card card-accent-success animated fadeIn">

                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de embalajes</strong>
                            </div>

                            <div class="card-body-grid">

                                <p-table #tableSearch autoLayout="true" [value]="solicitudProductos?.TwEmbalajesCollection"
                                         [columns]="colsEmbalajes" sortField="CodigoTaric" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(solicitudProductos?.TwEmbalajesCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>

                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='IdTaricEmbalajeDescripcion' && col.field!=='IdUnidadEmbalajeDescripcion')">
                                                    {{rowData[col.field]}}
                                                </span>

                                                <span *ngIf="(col.field === 'IdTaricEmbalajeDescripcion' || col.field === 'IdUnidadEmbalajeDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[60, '...'] }}
                                                </span>

                                                <div *ngIf="col.field==='Link'" class="btn-group">

                                                    <div *ngIf="productoEditable">
                                                        <button (click)="onEditEmbalaje(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="!productoEditable && !esRechazoParcial">
                                                        <button (click)="onEditEmbalaje(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="productoBorrable">
                                                        <button (click)="onDeleteEmbalaje(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="esRechazoParcial">
                                                        <!--ICONO rechazo parcial-->
                                                        <img class="icono-info-grid" src="{{null | IconoProdsEmbsRp}}" container="body" ngbTooltip="Este embalaje se encuentra en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." />
                                                    </div>

                                                    <div *ngIf="esRechazoParcial">
                                                        <div *ngIf="rowData['Aceptado'] === true"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" ngbTooltip="Este embalaje se encuentra ACEPTADO en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." /></div>
                                                        <div *ngIf="rowData['Aceptado'] === false"><img class="icono-info-grid-small" src="{{rowData['Aceptado'] | IconoProdsEmbsRpAceptado}}" container="body" ngbTooltip="Este embalaje se encuentra RECHAZADO en otra solicitud, generada al hacer el Rechazo Parcial. Consulte en los enlaces de la cabecera." /></div>

                                                    </div>

                                                </div>
                                            </td>
                                        </tr>

                                    </ng-template>
                                </p-table>
                                <div *ngIf="solicitudProductos?.TwEmbalajesCollection?.length === 0" class="empty-grid">
                                    No hay embalajes asociados a la solicitud
                                </div>
                            </div>
                            <!--CONTADOR DE BULTOS-->
                            <div *ngIf="solicitudProductos?.TwEmbalajesCollection?.length > 0" class="card-body-detalle-bot125">
                                <div class="col-md-2">
                                    <label class="col-form-label" for="inpTotalBultos">Nº Total de Bultos</label>
                                    <input readonly name="TotalBultos" title="" class="form-control" id="inpTotalBultos" type="text" value="{{ numeroBultosTotales }}">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--EMBALAJE ANTIGUO
                <div class="col-md-8" *ngIf="visibilityEmbalajes">
                    <div class="card card-accent-success animated fadeIn">
                        <a class="card-header-a" (click)="isCollapsedEmbalaje = !isCollapsedEmbalaje" [attr.aria-expanded]="!isCollapsedEmbalaje" aria-controls="collapseExample">
                            <div class="card-header-buscador">
                                <i class="fa fa-file-text-o"></i> <strong> Embalaje</strong>
                                <i *ngIf="isCollapsedEmbalaje" class="fa fa-caret-down float-right"></i>
                                <i *ngIf="!isCollapsedEmbalaje" class="fa fa-caret-up float-right"></i>
                            </div>
                        </a>

                        <div class="card-body-detalle">
                            <div class="collapse group-filtros" id="collapsedEmbalaje" [ngbCollapse]="isCollapsedEmbalaje">
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label class="col-form-label" for="inpNimf15">¿Cumple NIMF-15?</label>
                                        <div class="ui-g">
                                            <div class="ui-g-3">
                                                <p-radioButton formControlName="IdNimf15" inputStyleClass="form-control" name="IdNimf15" value="1" label="Sí"></p-radioButton>
                                            </div>
                                            <div class="ui-g-3">
                                                <p-radioButton formControlName="IdNimf15" inputStyleClass="form-control" name="IdNimf15" value="2" label="NO"></p-radioButton>
                                            </div>
                                            <div class="ui-g-3">
                                                <p-radioButton formControlName="IdNimf15" inputStyleClass="form-control" name="IdNimf15" value="3" label="No Aplica"></p-radioButton>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="form-group col-md-12">
                                        <label class="col-form-label" for="inpCodigo">Observaciones</label>
                                        <textarea style="resize:none" formControlName="Observaciones" maxlength="500" name="Observaciones" title="" class="form-control" inputStyleClass="form-control" type="text" value=""></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>-->

            </div>
        </div>
    </div>
</form>
